import React, { createContext, type ReactNode } from "react";

import { GET_LABEL_WIZARD_DATA_V3 } from "@gql/label-rules-v3";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type GetLabelWizardDataV3,
  type GetLabelWizardDataV3_me_labelFiltersV3,
} from "@north-beam/nb-client-side";

interface LabelWizard {
  labelFilters: GetLabelWizardDataV3_me_labelFiltersV3[];
  labelNames: string[];
  loading: boolean;
}

export const LabelWizardContext = createContext<LabelWizard | null>(null);

export const LabelWizardProvider = ({ children }: { children: ReactNode }) => {
  const { data, loading } = useNorthbeamQuery<GetLabelWizardDataV3>(
    GET_LABEL_WIZARD_DATA_V3,
    { useCpuIntensive: true },
  );

  return (
    <LabelWizardContext.Provider
      value={{
        labelFilters: data?.me.labelFiltersV3 || [],
        labelNames: (data?.me.labelRuleGroupsV3 || []).map((e) => e.name),
        loading,
      }}
    >
      {children}
    </LabelWizardContext.Provider>
  );
};
